import React, { useEffect, useMemo, useState } from "react";
import { Container, Row, Col, Button } from "react-bootstrap";
import {TVChartContainer} from "./component/TVChartContainer";
import { KLineChartContainer } from './component/KlineChart/KLineChartContainer';
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import TradingSidebar from "./component/TradingSidebar";
import * as API from "helpers/backend_helper";

// actions
import actions from "../../../store/actions";
import { hideLoader, showLoader } from "store/loader/loaderSlice";

// css
import "./TradingSec.scss";

// img
import candleBg from "../../../Assets/images/candleBg.png";
import { calculateMaxDates, calculateMaxDays, timeStampRange } from "helpers/common";
import moment from "moment";
import { isEmpty } from "lodash";
import { useGetWorkbookByIdQuery, useSaveWorkbookMutation } from "store/services/workbook.service";
import { useFetchProductDetailsQuery } from "store/services/user.service";
import WorkbooksSiderbar from "./component/WorkbooksSidebar/Index";
import Loader from "components/shared/Loader";
import ErrorComponent from "components/shared/ErrorComponent";
// import ChartView from "./component/ChartView";


const defaultProps = {
  locale: "en",
  libraryPath: "/charting_library/",
  interval: "1D",
  fullscreen: true,
  debug: true,
};

// Sample graph data
  const graphData = [
    { timestamp: '2024-01-01', open: 100, high: 105, low: 98, close: 103, volume: 1000 },
    { timestamp: '2024-01-02', open: 103, high: 108, low: 101, close: 106, volume: 1200 },
    // ... more data
  ];

  // Planet configuration
  const planets = [
    {
      key: 'sun_conjunction',
      name: 'Sun',
      enabled: true,
      aspect: 'conjunction',
      direction: 'forward',
      lineColor: '#FFD700',
      lineWidth: 1,
      lineStyle: 0, // 0 = solid, 1 = dashed
    },
    {
      key: 'moon_opposition',
      name: 'Moon',
      enabled: true,
      aspect: 'opposition',
      direction: 'both',
      lineColor: '#C0C0C0',
      lineWidth: 1,
      lineStyle: 0,
    },
    {
      key: 'mars_square',
      name: 'Mars',
      enabled: true,
      aspect: 'square',
      direction: 'forward',
      lineColor: '#FF4500',
      lineWidth: 2,
      lineStyle: 1, // dashed
    },
  ];

const Workbook = () => {
  const { _id } = useParams();
  const dispatch = useDispatch();

  const { data: userSubscriptionDetails, isLoading: subscriptionDetailsLoading } = useFetchProductDetailsQuery();

  const { isLoading, isError } = useGetWorkbookByIdQuery(_id);
  const [ saveWorkbook ] = useSaveWorkbookMutation();

  const { workbook, calendar } = useSelector((state) => state.workbook);

  const [location, setLocation] = useState({ latitude: null, longitude: null });
  const [chartLoading, setChartLoading] = useState(false);

  const [ maxDatePast, maxDateFuture ] = useMemo(() => {
    let startDate = userSubscriptionDetails?.current_period_start;
    let endDate = userSubscriptionDetails?.current_period_end;
    // let startDate = "2025-10-05 23:59:59";
    // let endDate = "2026-10-05 23:59:59";
    return calculateMaxDates(startDate, endDate)
  }, [userSubscriptionDetails])

  // Function to get the user's location
  const getLocation = () => {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        (position) => {
          setLocation({
            latitude: position.coords.latitude,
            longitude: position.coords.longitude,
          });
        },
        (err) => {
          console.log("error", err.message);
        }
      );
    }
  };

  useEffect(() => {
    getLocation();
  }, []);

  useEffect(() => {
    if (workbook) {
      const timeout = setTimeout(() => {
        saveWorkbook({ _id, workbook });
      }, 2000);

      return () => {
        clearTimeout(timeout);
      };
    }
  }, [_id, workbook]);

  return (
    <section
      className="workBook tradingSec pb-5"
      style={{
        backgroundColor: "#fafafa",
        backgroundImage: `url(${candleBg})`,
        backgroundSize: "cover",
        backgroundPosition: "top center",
        zIndex: 9,
      }}
    >
      {isLoading ? (
        <div className="fixed-loader">
          <Loader />
        </div>
      ): (isError || !workbook) ? (
        <ErrorComponent />
      ):(
        <Container fluid>
          <Row>
            <Col lg="3" className="TradingSidebar">
              <TradingSidebar
                maxDatePast={maxDatePast}
                maxDateFuture={maxDateFuture}
              />
            </Col>

            <Col lg="9">
              <div className="cardCstm bg-white p-2">
                <Row>
                  <Col lg="3" className="symbol-price-sidebar">
                    <WorkbooksSiderbar />
                  </Col>

                  <Col lg="9" className="my-2">
                    {/* <TVChartContainer
                      // key={workbook?._id}
                      defaultProps={defaultProps}
                      location={location}
                      calendar={calendar}
                      maxDatePast={maxDatePast}
                      maxDateFuture={maxDateFuture}
                      // maxDatePast={moment("25-09-2024", "DD-MM-YYYY").toDate()}
                      // maxDateFuture={moment("27-09-2024", "DD-MM-YYYY").toDate()}
                      workbook={workbook}
                      trendLineConfig={workbook.trendLineConfig}
                      loading={chartLoading}
                      setLoading={setChartLoading}
                    /> */}
                    {/* <TVChartContainer
                      // key={workbook?._id}
                      defaultProps={defaultProps}
                      toolName={workbook.toolName}
                      graphData={workbook.graph}
                      priceUnit={workbook.priceUnit}
                      planets={workbook.planets}
                      gmtOffset={workbook.gmtOffset}
                      location={location}
                      calendar={calendar}
                      maxDatePast={maxDatePast}
                      maxDateFuture={maxDateFuture}
                      // maxDatePast={moment("25-09-2024", "DD-MM-YYYY").toDate()}
                      // maxDateFuture={moment("27-09-2024", "DD-MM-YYYY").toDate()}
                      useChartPriceUnit={workbook.useChartPriceUnit}
                      chartPriceUnit={workbook.chartPriceUnit}
                      workbook={workbook}
                      trendLineConfig={workbook.trendLineConfig}
                      loading={chartLoading}
                      setLoading={setChartLoading}
                    /> */}
                    <KLineChartContainer
                      // key={workbook?._id}
                      defaultProps={defaultProps}
                      toolName={workbook.toolName}
                      graphData={workbook.graph}
                      priceUnit={workbook.priceUnit}
                      planets={workbook.planets}
                      gmtOffset={workbook.gmtOffset}
                      location={location}
                      calendar={calendar}
                      maxDatePast={maxDatePast}
                      maxDateFuture={maxDateFuture}
                      // maxDatePast={moment("25-09-2024", "DD-MM-YYYY").toDate()}
                      // maxDateFuture={moment("27-09-2024", "DD-MM-YYYY").toDate()}
                      useChartPriceUnit={workbook.useChartPriceUnit}
                      chartPriceUnit={workbook.chartPriceUnit}
                      workbook={workbook}
                      trendLineConfig={workbook.trendLineConfig}
                      helioCentrictrendLineConfig={workbook.helioCentrictrendLineConfig}
                      loading={chartLoading}
                      setLoading={setChartLoading}
                    />
                  </Col>
                </Row>
              </div>
            </Col>
          </Row>
        </Container>
      )}
    </section>
  );
};

export default Workbook;
